<div class="v-center" *ngIf="!article">
  <br/>
  <app-spinner></app-spinner>
</div>

<ng-container *ngIf="article">
  <div id="block">
    
    <div id="underbox" [ngClass]="homePageStyling ? 'home': ''">
      <a *ngIf="haveAccess" routerLink="/stories/{{article.franchise ? article.franchise.id : '-'}}/{{article.id}}">
        <div [ngClass]="homePageStyling ? 'image home-page': 'image'" [responsiveBackgroundImage]="article.lead_image" *ngIf="showImage">
        </div>
      </a>
      <a *ngIf="!haveAccess" href="{{joinUrl}}">
        <div [ngClass]="homePageStyling ? 'image home-page': 'image'" [responsiveBackgroundImage]="article.lead_image" *ngIf="showImage">
        </div>
      </a>
      <a id="franchise" *ngIf="article.franchise" routerLink="/stories/franchise/{{article.franchise.id}}">
        <i [responsiveBackgroundImage]="article.franchise.square_logo || article.franchise.image"></i>
        {{article.franchise.name}}
      </a>
      <div id="metadata" [ngClass]="homePageStyling ? 'metadata-home-page': ''">
        <div [ngClass]="homePageStyling ? 'article-title home-page': 'article-title'">
          <a *ngIf="haveAccess" routerLink="/stories/{{article.franchise ? article.franchise.id : '-'}}/{{article.id}}">{{article.feed_headline || article.title}}</a>
          <a *ngIf="!haveAccess" href="{{joinUrl}}">{{article.feed_headline || article.title}}</a>
        </div>
        <div [ngClass]="homePageStyling ? 'summary home' : 'summary'">
          {{article.feed_summary}}
        </div>
        <div class="article-subtext">
          <span *ngIf="article.members_only" class="members-only-container">
            <tyt-plus-locked *ngIf="audienceType !== 'member'"></tyt-plus-locked>
            <tyt-plus-tag *ngIf="audienceType === 'member'"></tyt-plus-tag>
          </span>
          <ng-container *ngIf="article.talent && article.talent.length > 0">
            <strong>By: </strong>
            <span>
              <ng-container *ngFor="let talent of article.talent; let i = index">
                <a id="talent" *ngIf="haveAccess" routerLink="/about/talent/{{talent.id}}"><span class="comma" *ngIf="i > 0">,&nbsp;</span>{{talent.name}}</a>
                <a id="talent" *ngIf="!haveAccess" href="{{joinUrl}}"><span class="comma" *ngIf="i > 0">,&nbsp;</span>{{talent.name}}</a>
              </ng-container>
            </span>
            <span class="divider">|</span>
          </ng-container>
          <span>{{date|date}}</span>
          <span class="divider">|</span>
          <tyt-comments-count identifier="article_{{article.id}}"></tyt-comments-count>
        </div>
      </div>
    </div>
  </div>

</ng-container>